// extracted by mini-css-extract-plugin
export var actionButton = "_qh-0";
export var actionMenuContainer = "_qh-i";
export var bubble = "_qh-2";
export var bubbleActionMenu = "_qh-j";
export var bubbleContext = "_qh-6";
export var bubbleItems = "_qh-7";
export var customer = "_qh-3";
export var divider = "_qh-8";
export var fileList = "_qh-9";
export var hiddenComment = "_qh-o";
export var infoAbove = "_qh-a";
export var internal = "_qh-4";
export var lightActionButton = "_qh-1";
export var link = "_qh-b";
export var merchant = "_qh-5";
export var message = "_qh-c";
export var profilePicture = "_qh-e";
export var quillToolbarContainer = "_qh-f";
export var senderDate = "_qh-g";
export var senderDateCustomer = "_qh-h";
export var senderName = "_qh-d";
export var time = "_qh-k";
export var uploadedImage = "_qh-l";
export var username = "_qh-m";
export var xsmall = "_qh-n";